export enum SinglePageCard {
  BILLINGADDRESS = 'BILLINGADDRESS',
  CONTACTINFO = 'CONTACTINFO',
  GIFTING = 'GIFTING',
  PAYMENT = 'PAYMENT',
  SAMEDAY = 'SAMEDAY',
  SHIPPINGADDRESS = 'SHIPPINGADDRESS',
  UNKNOWN = 'UNKNOWN',
}
